import React from 'react'

/** Redux **/
import { useSelector } from 'react-redux'

/** Material UI **/
import {
  Backdrop,
  Box,
  CircularProgress,
  CssBaseline,
  Grid,
  makeStyles
} from '@material-ui/core'

/** Components **/
import cornerLogo from '../assets/images/corner_logo.svg'

const useStyles = makeStyles(theme => ({
  container: {
    height: '100vh',
    overflowY: 'scroll',
    flexDirection: 'column',
    [theme.breakpoints.down('sm')]: {
      overflowY: 'scroll'
    }
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: theme.colors.backdropColor
  },
  imageContainer: {
    width: 'calc(100% - 720px)',
    overflow: 'hidden'
  },
  body: {
    minHeight: 'calc(100vh - 170px)',
    backgroundColor: theme.colors.backdropColor,
    textAlign: 'center',
    display: 'flex',
    justifyContent: 'center',
    '&::-webkit-scrollbar': {
      display: 'none'
    }
  },
  background: {
    backgroundColor: theme.colors.backdropColor
  },
  containerIconLogo: {
    position: 'absolute',
    left: '0px',
    bottom: '0px',
    width: 'fit-content',
    [theme.breakpoints.down('sm')]: {
      left: 0,
      right: 0,
      marginleft: 'auto',
      marginright: 'auto'
    },
    [theme.breakpoints.down('xs')]: {
      display: 'none'
    }
  },
  cornerIcon: {
    position: '',
    bottom: '0px',
    left: '0px',
    maxWidth: '25vw'
  }
}))

export const AdminContainer = props => {
  const loading = useSelector(state => state.loading.loading)
  const classes = useStyles()

  return (
    <div className={classes.background} hidden={loading}>
      <CssBaseline />
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box className={classes.container}>
        <Box className={classes.body}>{props.children}</Box>
      </Box>
      <Grid className={classes.containerIconLogo} item xs={12}>
        <img
          alt={'CornerIconLogo'}
          className={classes.cornerIcon}
          src={cornerLogo}
        />
      </Grid>
    </div>
  )
}
